import { Box, GlobalStyles } from '@mui/material';
import Loading from 'components/common/Loading';
import PDFPreviewLazy from 'components/common/PDFPreviewLazy';
import { any } from 'prop-types';
import React from 'react';

const DOC_CLASS = 'modals-pdf-preview-doc';
const PAGE_CLASS = 'modals-pdf-preview-page';

const pdfGlobalStyles = {
  [`.${DOC_CLASS}`]: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    alignItems: 'center',
    flex: 1,
  },
  [`.${PAGE_CLASS}`]: {
    width: 'fit-content',
    margin: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#fff',
    boxShadow:
      '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%)',
    overflow: 'hidden',
  },
};

const PdfPreview = ({ src, ...rest }) => (
  <>
    <GlobalStyles styles={pdfGlobalStyles} />
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#f2f4f7',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        '&::after': {
          content: `''`,
          position: 'absolute',
          boxShadow: 'inset 0px 0px 10px rgba(0,0,0,0.1)',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          pointerEvents: 'none',
        },
      }}
    >
      <Box
        sx={{
          height: '100%',
          position: 'relative',
          overflow: 'scroll',
        }}
      >
        <PDFPreviewLazy
          {...rest}
          pageClassName={PAGE_CLASS}
          docClassName={DOC_CLASS}
          file={src}
          loading={<Loading sx={{ mt: '20px' }} size={60} />}
        />
      </Box>
    </Box>
  </>
);

PdfPreview.propTypes = {
  src: any.isRequired,
};

export default PdfPreview;
